export default __webpack_public_path__ + "static/media/next-arrow.a57edc66.svg";